import { Marker, MarkerContent, MarkerIcon } from "@/components/ui/marker";
import { Spinner } from "@/components/ui/spinner";

export function ContextCompactionMarker({
	status,
}: {
	status: "compacting" | "ready";
}) {
	if (status === "ready") {
		return (
			<div className="w-full px-4 py-3">
				<Marker variant="separator">
					<MarkerContent>Conversation compacted</MarkerContent>
				</Marker>
			</div>
		);
	}

	return (
		<div className="w-full px-4 py-3">
			<Marker role="status" aria-live="polite">
				<MarkerIcon>
					<Spinner role="presentation" aria-label={undefined} />
				</MarkerIcon>
				<MarkerContent>Compacting conversation</MarkerContent>
			</Marker>
		</div>
	);
}
